var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("invoice-send-modal", {
        ref: "invoiceSendModal",
        on: { sent: _vm.refreshInvoice }
      }),
      _c("invoice-payment-modal", {
        ref: "invoicePaymentModal",
        attrs: { includes: _vm.includes },
        on: { updatedInvoice: _vm.handleInvoiceUpdate }
      }),
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _vm.invoice
            ? _c(
                "q-toolbar-title",
                [
                  _c("strong", [_vm._v(_vm._s(_vm.$tc("invoice", 1)))]),
                  _vm._v(
                    " #" + _vm._s(_vm.invoice.invoice_number) + "\n\n      "
                  ),
                  _c("status-chip", {
                    staticClass: "on-right",
                    attrs: {
                      small: "",
                      status: _vm.invoice.status,
                      committed: _vm.isCommitted,
                      color: _vm.statusColor,
                      clickable: _vm.user.isUserOfActiveTeam()
                    },
                    on: {
                      cancel: function($event) {
                        _vm.handleCancelInvoice(_vm.invoice.id)
                      },
                      paid: _vm.handleFullPayment,
                      open: _vm.handleMarkInvoiceAsOpen
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("icon-bar", { attrs: { items: _vm.iconBarItems } })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "layout-padding",
          class: { "q-pt-none": _vm.isCanceled || _vm.isCancellationInvoice }
        },
        [
          _vm.invoice && (_vm.isCanceled || _vm.isCancellationInvoice)
            ? _c(
                "div",
                { staticClass: "row justify-center q-px-md q-py-lg" },
                [
                  _c("q-btn-toggle", {
                    staticClass: "invoice__storno-toggle",
                    attrs: {
                      "toggle-color": "dark",
                      outline: "",
                      options: [
                        { label: _vm.$t("original"), value: "invoice" },
                        {
                          label: _vm.$t("cancel_invoice_title"),
                          value: "storno"
                        }
                      ]
                    },
                    model: {
                      value: _vm.view,
                      callback: function($$v) {
                        _vm.view = $$v
                      },
                      expression: "view"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.invoice
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-6 col-xl-7" },
                  [
                    _c("document-viewer", { attrs: { document: _vm.document } })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-6 col-xl-5" },
                  [
                    _c(
                      "q-tabs",
                      {
                        attrs: { color: "tertiary", "underline-color": "white" }
                      },
                      [
                        _c("q-tab", {
                          attrs: {
                            slot: "title",
                            label: _vm.$t("invoice_meta"),
                            name: "meta",
                            default: ""
                          },
                          slot: "title"
                        }),
                        !_vm.isCancellationInvoice
                          ? _c("q-tab", {
                              attrs: {
                                slot: "title",
                                label: _vm.$tc("payment", 2),
                                name: "payment"
                              },
                              slot: "title"
                            })
                          : _vm._e(),
                        _c("q-tab", {
                          attrs: {
                            slot: "title",
                            label: _vm.$tc("note", 2),
                            name: "notes"
                          },
                          slot: "title"
                        }),
                        _c(
                          "q-tab-pane",
                          { staticClass: "bg-white", attrs: { name: "meta" } },
                          [
                            _c(
                              "q-item",
                              { staticClass: "invoice__invoice-date-entry" },
                              [
                                _c("q-item-main", {
                                  attrs: {
                                    label: _vm.invoiceDate,
                                    sublabel: _vm.$t("invoice_date")
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.deliveryDate
                              ? _c(
                                  "q-item",
                                  {
                                    staticClass: "invoice__invoice-date-entry"
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: {
                                        label: _vm.deliveryDate,
                                        sublabel: _vm.$t("delivery_date")
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.dueDate
                              ? _c(
                                  "q-item",
                                  { staticClass: "invoice__due-date-entry" },
                                  [
                                    _c("q-item-main", {
                                      attrs: {
                                        label: _vm.dueDate,
                                        sublabel: _vm.$t("due_date")
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.cashDiscountLimitDate
                              ? _c(
                                  "q-item",
                                  { staticClass: "invoice__due-date-entry" },
                                  [
                                    _c("q-item-main", {
                                      attrs: {
                                        label: _vm.cashDiscountLabel,
                                        sublabel: _vm.$t("cash_discount")
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.createdBy
                              ? _c(
                                  "q-item",
                                  { staticClass: "invoice__due-date-entry" },
                                  [
                                    _c("q-item-main", {
                                      attrs: {
                                        label: [
                                          _vm.createdBy.first_name,
                                          _vm.createdBy.last_name
                                        ].join(" "),
                                        sublabel: _vm.$t("invoice_created_by")
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "q-item",
                              { staticClass: "invoice__customer-name-entry" },
                              [
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { label: "" } },
                                      [
                                        _vm.invoice.customer_exists
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass: "router-link",
                                                attrs: {
                                                  to: {
                                                    name: "customer",
                                                    params: {
                                                      customerId:
                                                        _vm.customer.id,
                                                      teamId: _vm.activeTeam.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(_vm.customerName) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.customerName) +
                                                  "\n                  "
                                              )
                                            ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$tc("customer", 1)) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.contactPersonName
                              ? _c(
                                  "q-item",
                                  { staticClass: "invoice__due-date-entry" },
                                  [
                                    _c("q-item-main", {
                                      attrs: {
                                        label: _vm.contactPersonName,
                                        sublabel: _vm.$tc("contact_person", 1)
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.invoice.invoice_address
                              ? _c(
                                  "q-item",
                                  {
                                    staticClass:
                                      "invoice__invoice-address-entry"
                                  },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c("q-item-tile", {
                                          attrs: { label: "" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.invoice.invoice_address.data
                                                .formatted_address
                                            )
                                          }
                                        }),
                                        _c(
                                          "q-item-tile",
                                          { attrs: { sublabel: "" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("invoice_address")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.invoice.quote_id
                              ? _c(
                                  "q-item",
                                  {
                                    staticClass: "invoice__customer-name-entry"
                                  },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c(
                                          "q-item-tile",
                                          { attrs: { label: "" } },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "router-link",
                                                attrs: {
                                                  to: {
                                                    name: "quote",
                                                    params: {
                                                      quote:
                                                        _vm.invoice.quote_id,
                                                      teamId: _vm.activeTeam.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.invoice.quote.data
                                                        .quote_number
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-tile",
                                          { attrs: { sublabel: "" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$tc("quote", 1)) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.invoice.project_id
                              ? _c(
                                  "q-item",
                                  { staticClass: "invoice__project-entry" },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c(
                                          "q-item-tile",
                                          { attrs: { label: "" } },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "router-link",
                                                attrs: {
                                                  to: {
                                                    name: "project",
                                                    params: {
                                                      project:
                                                        _vm.invoice.project_id,
                                                      teamId: _vm.activeTeam.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.invoice.project.data
                                                        .name
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-tile",
                                          { attrs: { sublabel: "" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$tc("project", 1)) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        !_vm.isCancellationInvoice
                          ? _c(
                              "q-tab-pane",
                              {
                                staticClass: "bg-white",
                                attrs: { name: "payment" }
                              },
                              [
                                _vm.showPaymentsButton
                                  ? _c(
                                      "q-item",
                                      {
                                        staticClass:
                                          "invoice__invoice-payment-button"
                                      },
                                      [
                                        _c(
                                          "q-item-main",
                                          [
                                            _c(
                                              "q-btn-dropdown",
                                              {
                                                attrs: {
                                                  label: _vm.$t("mark_paid"),
                                                  split: "",
                                                  outline: ""
                                                },
                                                on: {
                                                  click: _vm.handleFullPayment
                                                }
                                              },
                                              [
                                                _c(
                                                  "q-list",
                                                  { attrs: { link: "" } },
                                                  [
                                                    _c(
                                                      "q-item",
                                                      {
                                                        directives: [
                                                          {
                                                            name:
                                                              "close-overlay",
                                                            rawName:
                                                              "v-close-overlay"
                                                          }
                                                        ],
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleAddPayment(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "q-item-main",
                                                          [
                                                            _c(
                                                              "q-item-tile",
                                                              {
                                                                attrs: {
                                                                  label: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "add_payment"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._l(_vm.payments, function(payment) {
                                  return _c(
                                    "q-item",
                                    {
                                      key: payment.id,
                                      staticClass:
                                        "invoice__invoice-payment-entry"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c(
                                            "q-item-tile",
                                            { attrs: { label: "" } },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("money")(
                                                      payment.balance,
                                                      _vm.invoice.currency
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-item-tile",
                                            { attrs: { sublabel: "" } },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      payment.payment_date.date,
                                                      _vm.$t("date_format")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              payment.payment_method
                                                ? _c("span", [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            payment.payment_method
                                                          )
                                                        )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "q-item-side",
                                        { attrs: { right: "" } },
                                        [
                                          _c("q-btn", {
                                            directives: [
                                              {
                                                name: "is-user",
                                                rawName: "v-is-user"
                                              }
                                            ],
                                            attrs: {
                                              icon: "close",
                                              flat: "",
                                              dense: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.handleDeletePayment(payment)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                !_vm.payments.length
                                  ? _c(
                                      "q-item",
                                      {
                                        staticClass:
                                          "text-italic row justify-center q-mt-lg"
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("payments_empty")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "q-tab-pane",
                          { staticClass: "bg-white", attrs: { name: "notes" } },
                          [
                            _c("note-input", {
                              staticStyle: { height: "250px" },
                              attrs: {
                                notes: _vm.notes,
                                createNoteMethod: _vm.handleCreateNote,
                                updateNoteMethod: _vm.handleUpdateNote,
                                deleteNoteMethod: _vm.handleDeleteNote,
                                hideEmptyState: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c("q-tab-pane", { attrs: { name: "tab-5" } }, [
                          _vm._v("Tab Five")
                        ])
                      ],
                      1
                    ),
                    _vm.activities
                      ? _c(
                          "q-card",
                          { staticClass: "bg-white q-mt-lg" },
                          [
                            _c(
                              "q-card-main",
                              [
                                _c("timeline", {
                                  attrs: { activities: _vm.activities }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }